export const SnakeLayoutCellWidth = 60;
